import { useQuery } from '@tanstack/react-query'
import { AlternativeContactsService } from '@/shared/api/rest/services/alternative-contacts.service'

/**
 * Fetch all guardians (alternative contacts) linked to a parent's children in
 * a single request (`GET /alternative-contacts/by-parent/:parentId`), rather
 * than one `GET /children/:id` call per rendered child card (N+1).
 */
export const useParentGuardians = (parentId?: string) => {
    const query = useQuery({
        queryKey: ['parent-guardians', parentId],
        queryFn: () => AlternativeContactsService.byParent(parentId as string),
        enabled: Boolean(parentId),
        staleTime: 5 * 60 * 1000
    })

    const guardians = query.data ?? []

    const guardiansByChildId = (childId: string) =>
        guardians.filter((guardian) =>
            guardian.children?.some((child) => child._id === childId)
        )

    return { guardiansByChildId, loading: query.isLoading }
}
